import { useTranslation } from "react-i18next";
import { cn } from "@/shared/lib/utils";
import type { FoundingStatus } from "./types";

const STATUS_CLASS: Record<FoundingStatus, string> = {
  INTRO: "bg-sky-100 text-sky-800",
  ONGOING: "bg-emerald-100 text-emerald-800",
  FLAT: "bg-emerald-100 text-emerald-800",
  UNASSIGNED: "bg-amber-100 text-amber-800",
  LAPSED: "bg-muted text-muted-foreground",
};

interface FoundingStatusBadgeProps {
  readonly status: FoundingStatus;
  readonly testId?: string;
}

export function FoundingStatusBadge({ status, testId }: FoundingStatusBadgeProps) {
  const { t } = useTranslation();
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 font-sans text-xs font-medium",
        STATUS_CLASS[status],
      )}
    >
      {t(`founding.status.${status}`)}
    </span>
  );
}
